import React from 'react';
import Svg, { G, Path } from 'react-native-svg';

export interface ISvgProps
{
//   manageScroll(iMsg    : number,
//                oParam? : any) : any;

  scale : number;
  color : string;
}

export default function SvgDarkMode(props : ISvgProps) {
    return (
      <Svg width="100%" height="100%">
        <G  scale={props.scale}>
          <Path stroke={props.color} fill={props.color} strokeWidth={0} d="M17.75,4.09L15.22,6.03L16.13,9.09L13.5,7.28L10.87,9.09L11.78,6.03L9.25,4.09L12.44,4L13.5,1L14.56,4L17.75,4.09M21.25,11L19.61,12.25L20.2,14.23L18.5,13.06L16.8,14.23L17.39,12.25L15.75,11L17.81,10.95L18.5,9L19.19,10.95L21.25,11M18.97,15.95C19.8,15.87 20.69,17.05 20.16,17.8C19.84,18.25 19.5,18.67 19.08,19.07C15.17,23 8.84,23 4.94,19.07C1.03,15.17 1.03,8.83 4.94,4.93C5.34,4.53 5.76,4.17 6.21,3.85C6.96,3.32 8.14,4.21 8.06,5.04C7.79,7.9 8.75,10.87 10.95,13.06C13.14,15.26 16.1,16.22 18.97,15.95M17.33,17.97C14.5,17.81 11.7,16.64 9.53,14.5C7.36,12.31 6.2,9.5 6.04,6.68C3.23,9.82 3.34,14.64 6.35,17.66C9.37,20.67 14.19,20.78 17.33,17.97Z"/>
        </G>
      </Svg>
    );
  } 

export function SvgSortAZ(props : ISvgProps) {
  return (
    <Svg width='100%' height='100%'>
      <G  scale={props.scale}>
        <Path stroke={props.color} fill={props.color} strokeWidth={0.1} d="M19 17H22L18 21L14 17H17V3H19M11 13V15L7.67 19H11V21H5V19L8.33 15H5V13M9 3H7C5.9 3 5 3.9 5 5V11H7V9H9V11H11V5C11 3.9 10.11 3 9 3M9 7H7V5H9Z"/>
      </G>
    </Svg>
  );
} 

export function SvgSortZA(props : ISvgProps) {
  return (
    <Svg width='100%' height='100%'>
      <G  scale={props.scale}>
        <Path stroke={props.color} fill={props.color} strokeWidth={0} d="M19 7H22L18 3L14 7H17V21H19M11 13V15L7.67 19H11V21H5V19L8.33 15H5V13M9 3H7C5.9 3 5 3.9 5 5V11H7V9H9V11H11V5C11 3.9 10.11 3 9 3M9 7H7V5H9Z"/>
      </G>
    </Svg>
  );
} 